"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const IconArrow_1 = __importDefault(require("@/assets/icons/IconArrow"));
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const LinkButton = ({ url }) => {
    return (react_1.default.createElement(react_router_dom_1.Link, { to: url, style: { padding: '0 10px', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
        react_1.default.createElement(IconArrow_1.default, null)));
};
exports.default = LinkButton;
